import TrackedLinkContainer from './containers/TrackedLinkContainer';

export default TrackedLinkContainer;
